module.exports = __webpack_public_path__ + "img/ImRad.121ff863.svg";